<template>
  <div class="box mb-5">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <v-flex xs12>
        <h2 class="box-header-item mb-3 mb-md-0" v-html="$t('firm-box.title')"></h2>
      </v-flex>
    </v-layout>

    <div class="box-content">
      <v-list>
        <transition-group name="fade">
          <template v-for="(firm, index) in firms">
            <v-divider
              v-if="index != 0"
              :key="index"
              inset
            ></v-divider>

            <v-list-item :key="firm.id" class="py-5">
              <IDCard
                :id="firm ? firm.id : null"
                :title="firm ? firm.title : null"
                :address="firm ? firm.address : null"
                :city="firm ? firm.city : null"
                :zip="firm ? firm.zip : null"
                :vat="firm ? firm.vat : null"
                :nr="firm ? firm.nr : null"
                :reg="firm ? firm.reg : null"
                reload
                @editFirmToParent="reloadFirm"
                class="d-block w-100"
              ></IDCard>
              <!-- Icon -->
              <v-list-item-icon style="position: absolute; top: 10%; right: 0;">
                <v-btn text small @click="dialogDeleteFirm = true; toDeleteFirm = firm">
                  <v-icon color="error" size="11">icon-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </transition-group>
      </v-list>

      <div class="text-center">
        <v-btn
          :elevation="0"
          rounded
          color="primary"
          small
          @click="dialogCreateFirm = true"
          class="mt-2"
          v-html="$t('firm-box.cta')"
        ></v-btn>
      </div>
    </div>

    <!-- Dialog delete firm -->
    <v-dialog
      v-model="dialogDeleteFirm"
      max-width="650"
    >
      <v-card class="ma-0">
        <v-card-title class="headline" v-html="`${$t('firm-box.dialog-1.title')} ${toDeleteFirm ? toDeleteFirm.title : $t('firm-box.dialog-1.nofirm')}`"></v-card-title>

        <v-card-text>
          {{ $t('firm-box.dialog-1.warning') }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            text
            color="error"
            @click="dialogDeleteFirm = false"
          >
            {{ $t('firm-box.dialog-1.btn-1') }}
          </v-btn>
          <v-btn
            outlined
            rounded
            color="primary"
            :disabled="!toDeleteFirm"
            @click="deleteAFirm(toDeleteFirm.id)"
          >
            {{ $t('firm-box.dialog-1.btn-2') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog><!-- Dialog delete firm -->

    <!-- Dialog create firm -->
    <v-dialog
      v-model="dialogCreateFirm"
      max-width="650"
    >
      <v-card class="ma-0">
        <v-card-title class="headline">{{ $t('firm-box.dialog-2.title') }}</v-card-title>

        <v-form
          v-model="valid"
          @submit.prevent="addFirm"
        >
          <v-card-text>
            <v-container>
              <!-- title -->
              <v-flex xs12>
                <v-text-field
                  v-model="title"
                  :label="$t('firm-box.dialog-2.label-1')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- title -->

              <!-- address -->
              <v-flex xs12>
                <v-text-field
                  v-model="address"
                  :label="$t('firm-box.dialog-2.label-3')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- address -->

              <!-- city -->
              <v-flex xs12>
                <v-text-field
                  v-model="city"
                  :label="$t('firm-box.dialog-2.label-2')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- city -->

              <!-- zip -->
              <v-flex xs12>
                <v-text-field
                  v-model="zip"
                  :label="$t('firm-box.dialog-2.label-4')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.number]"
                ></v-text-field>
              </v-flex><!-- zip -->

              <!-- vat -->
              <v-flex xs12>
                <v-text-field
                  v-model="vat"
                  :label="$t('firm-box.dialog-2.label-5')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- vat -->

              <!-- nr -->
              <v-flex xs12>
                <v-text-field
                  v-model="nr"
                  :label="$t('firm-box.dialog-2.label-6')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- nr -->

              <!-- reg -->
              <v-flex xs12>
                <v-text-field
                  v-model="reg"
                  :label="$t('firm-box.dialog-2.label-7')"
                  outlined
                  class="mandatory"
                  required
                  aria-required
                  :rules="[rules.notEmpty]"
                ></v-text-field>
              </v-flex><!-- reg -->
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              text
              color="error"
              @click="dialogCreateFirm = false"
            >
              {{ $t('firm-box.dialog-2.btn-1') }}
            </v-btn>
            <v-btn
              outlined
              rounded
              color="primary"
              type="submit"
              :disabled="title && city && address && zip && vat && nr && reg && /^[0-9]+$/.test(zip) ? false : true"
            >
              {{ $t('firm-box.dialog-2.btn-2') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog><!-- Dialog create firm -->
  </div>
</template>

<script>
import { getFirm } from '@/js/firm/getFirm'
import { createFirm } from '@/js/firm/createFirm'
import { deleteFirm } from '@/js/firm/deleteFirm'
import IDCard from '@/components/firm/IDCard'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  components: {
    IDCard: IDCard,
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      firms: null,
      valid: false,
      dialogCreateFirm: false,
      dialogDeleteFirm: false,
      toDeleteFirm: null,

      title: '',
      city: '',
      address: '',
      zip: '',
      vat: '',
      nr: '',
      reg: '',

      rules: {
        notEmpty: value => {
          if (value === '') return true
          const reg = /^\s+$/
          if (reg.test(value) === true) return this.$t('rules-field.empty')
          else return true
        },
        number: value => {
          if (value === '') return true
          const reg = /^[0-9]+$/ // should contain number
          return reg.test(value) || this.$t('rules-field.number')
        }
      },

      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    getFirm(this.$store.state.auth.token)
      .then(response => {
        this.firms = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })
  },

  methods: {
    addFirm () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      const { title, city, address, zip, vat, nr, reg } = this
      const params = {
        address: address,
        city: city,
        title: title,
        zip: zip,
        vat: vat,
        nr: nr,
        reg: reg,
        key: this.$store.state.auth.token
      }
      createFirm(params)
        .then(response => {
          this.dialogCreateFirm = false
          this.reloadFirm()
        })
        .catch(() => {
          this.dialogCreateFirm = false
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    deleteAFirm (firmid) {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      const params = {
        id: firmid,
        key: this.$store.state.auth.token
      }
      deleteFirm(params)
        .then(response => {
          this.dialogDeleteFirm = false
          this.reloadFirm()
        })
        .catch(() => {
          this.dialogDeleteFirm = false
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    reloadFirm () {
      // if (!this.$store.getters['auth/isAuthenticated']) return
      getFirm(this.$store.state.auth.token)
        .then(response => {
          this.firms = response
        })
        .catch(() => {
          this.httpalert = true
          setTimeout(() => {
            this.httpalert = false
          }, 4000)
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
